/**
 * generate a sequence of steps for stepper components
 * @param {number} steps 
 * @returns
 */
export const generateSteps = <T>(steps:number):T[] => {
    let arr:T[] = [];
    let obj:T | {} = {};
    for(let i=1; i<=steps; i++){
        obj = {
            label: i.toString(),
            status: "process"
        };
        arr.push(obj as T);
    }

    return arr;
}